<template>
  <base-section
    id="regional-contacts"
  >
    <v-container>
      <base-section-heading
      title="Regional Contacts"
      >
        ETS'23 is the partner of prestigious and important conferences all around the world. Thanks to the regional liaison chairs who helped to maximize the geographical distribution of ETS'23.
      </base-section-heading>
      <v-row>
        <base-avatar-card
          title="Regional Liaison Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(regional, i) in regionals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="regional"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <base-title
        title="Regional Contacts"
        size="text-h4"
        class="text-left"
      />
      <br>
      <v-row>
        <base-avatar-card
          title="Europe"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(eu, i) in europe"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="eu"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Latin America"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(la, i) in latin"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="la"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="North America"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(na, i) in north"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="na"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Africa and Middle East"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(a, i) in africa"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="a"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="South Asia"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(sa, i) in south"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="sa"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="East Asia"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(ea, i) in east"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="ea"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in partnersfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < partnersfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'RegionalContacts',

    data: () => ({
      isMobile: false,
      partnersfooter: [
        {
          name: 'Partner Conferences',
          url: 'map',
        },
        {
          name: 'Regional Contacts',
          url: 'regional-contacts',
        },
      ],
      regionals: [
        {
          title: 'Sule Ozev',
          src: require('@/images/committees/suleozev.jpg'),
          text: 'Arizona State University, USA',
        },
        {
          title: 'Ernesto Sanchez',
          src: require('@/images/committees/ernestosanchez.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      europe: [
        {
          title: 'Michele Portolan',
          src: require('@/images/committees/micheleportolan.jpg'),
          text: 'TIMA Université Grenoble Alpes, FR',
        },
        {
          title: 'Petr Fiser',
          src: require('@/images/committees/petrfiser.jpg'),
          text: 'Czech Technical University in Prague, CZ',
        },
      ],
      latin: [
        {
          title: 'Leticia Poehls Bolzani',
          src: require('@/images/committees/leticiabolzani.jpg'),
          text: 'Aachen University, DE',
        },
        {
          title: 'Felipe Restrepo',
          src: require('@/images/committees/feliperestrepo.jpg'),
          text: 'Bogota University, COL',
        },
      ],
      north: [
        {
          title: 'Nagmeh Karimi',
          src: require('@/images/committees/nagmehkarimi.jpg'),
          text: 'University of Maryland, Baltimore County, US',
        },
        {
          title: 'Ujjwal Guin',
          src: require('@/images/committees/ujjwalguin.jpg'),
          text: 'Auburn University, US',
        },
      ],
      africa: [
        {
          title: 'Nourhan Elhamawy',
          src: require('@/images/committees/nourhanelhamawy.png'),
          text: 'Stuttgart University, DE',
        },
        {
          title: 'Michail Maniatakos',
          src: require('@/images/committees/michailmaniatakos.jpg'),
          text: 'NYU Abu Dhabi, AD',
        },
      ],
      south: [
        {
          title: 'Lakshmanan Balasubramanian',
          src: require('@/images/committees/lakshmanan.jpg'),
          text: 'Texas Instruments, IND',
        },
        {
          title: 'Rubin Parekhji',
          src: require('@/images/committees/rubinparekhji.jpg'),
          text: 'Texas Instruments, IND',
        },
      ],
      east: [
        {
          title: 'Haruo Kobayashi',
          src: require('@/images/committees/haruokobayashi.jpg'),
          text: 'Gunma University, JP',
        },
        {
          title: 'Li Xiaowei',
          src: require('@/images/committees/lixiaowei.jpg'),
          text: 'Chinese Academy of Sciences, CH',
        },
        {
          title: 'Mango Chia-Tso Chao',
          src: require('@/images/committees/mangochiatsochao.jpg'),
          text: 'National Yang Ming Chiao Tung University, TW',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
